package com.schoolconnect.app.datasource.network

private val uuidPattern = Regex("^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$")

internal fun encodeQueryComponent(value: String): String = buildString {
    value.forEach { char ->
        when (char) {
            ' ' -> append("%20")
            '+' -> append("%2B")
            '&' -> append("%26")
            '?' -> append("%3F")
            '=' -> append("%3D")
            '%' -> append("%25")
            '#' -> append("%23")
            else -> append(char)
        }
    }
}

internal fun encodePathSegment(value: String): String =
    encodeQueryComponent(value).replace("/", "%2F")

internal fun optionalUuidQueryValue(value: String?): String? {
    val normalized = value?.trim() ?: return null
    return normalized.takeIf { it.matches(uuidPattern) }
}

internal fun buildUrlWithQuery(
    baseUrl: String,
    vararg params: Pair<String, String?>
): String {
    val query = params.mapNotNull { (key, value) ->
        value?.trim()?.takeIf { it.isNotBlank() }?.let { "$key=${encodeQueryComponent(it)}" }
    }
    if (query.isEmpty()) return baseUrl
    return buildString {
        append(baseUrl)
        append('?')
        append(query.joinToString("&"))
    }
}
